import { API, axiosInstance } from "lib";

export const getUserSifarishAll = (data = {}) => {
  return axiosInstance
    .get(
      API.GET_USER_SIFARISH +
        `?` +
        `userId=${data?.userId}&page=${data?.page}&limit=${
          data?.limit
        }&createdByUserId=${data?.createdByUserId}&search=${
          data?.search ? data?.search : ""
        }`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      throw err;
    });
};

export const getUserSifarish = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("createdByUserId", data?.createdByUserId);
  queryParams.append("subCategoryId", data?.subCategoryId);
  queryParams.append("birdId", data?.birdId);
  queryParams.append("startDate", data?.startDate);
  queryParams.append("endDate", data?.endDate);
  queryParams.append("search", data?.search || "");
  queryParams.append("showReportedOnly", data?.showReportedOnly || "");
  queryParams.append("deleteStatus", data?.deleteStatus || "");
  queryParams.append("keyword", data?.keyword || "");

  // Properly add categoryIds[] as multiple entries
  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.GET_USER_SIFARISH}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getReportedSifarish = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("createdByUserId", data?.createdByUserId);
  queryParams.append("userIdWhoReported", data?.userIdWhoReported || "");
  queryParams.append("subCategoryId", data?.subCategoryId || "");
  queryParams.append("birdId", data?.birdId);
  queryParams.append("startDate", data?.startDate || "");
  queryParams.append("endDate", data?.endDate || "");
  queryParams.append("search", data?.search || "");
  queryParams.append("showReportedOnly", data?.showReportedOnly || "");
  queryParams.append("deleteStatus", data?.deleteStatus || "");
  queryParams.append("activeStatus", data?.activeStatus || "");
  queryParams.append("keyword", data?.keyword || "");
  queryParams.append("city", data?.city || "");
  queryParams.append("state", data?.state || "");
  queryParams.append("country", data?.country || "");

  // Properly add categoryIds[] as multiple entries
  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.REPORTED_SIFARISH}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getUserCompleteSifarishData = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId || "");
  queryParams.append("userIdToFetch", data?.userIdToFetch || "");
  queryParams.append("categoryIds", data?.categoryIds || "");
  queryParams.append("subCategoryId", data?.subCategoryId || "");
  queryParams.append("birdId", data?.birdId || "");
  queryParams.append("city", data?.city || "");
  queryParams.append("state", data?.state || "");
  queryParams.append("country", data?.country || "");
  queryParams.append("sortBy", data?.sortBy || "");
  queryParams.append("showOnlyPublic", data?.showOnlyPublic || "");
  queryParams.append("activeStatus", data?.activeStatus || "");

  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.USER_COMPLETE_SIFARISH}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getSifarishPoints = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("startDate", data?.startDate);
  queryParams.append("endDate", data?.endDate);
  queryParams.append("type", data?.type || "");
  queryParams.append("userIdToFetch", data?.userIdToFetch || "");

  // Properly add categoryIds[] as multiple entries
  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.GET_SIFARISH_POINTS}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getLeaderboardData = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("isAdmin", true);
  // queryParams.append("endDate", data?.endDate);

  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.GET_LEADERBOARD}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getUserSifarishDetails = (data = {}) => {
  return axiosInstance
    .get(
      API.GET_USER_SIFARISH_DETAILS +
        `?` +
        `userId=${data?.userId}&sifarishId=${data?.sifarishId}`
    )
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      throw err;
    });
};

export const deleteSifarishData = (data = {}) => {
  return axiosInstance
    .post(API.DELETE_USER_SIFARISH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
      }
      throw err;
    });
};

export const addUserSifarish = (data = {}) => {
  return axiosInstance
    .post(API.ADD_USER_SIFARISH, data)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export const addSifarishPoints = (data = {}) => {
  return axiosInstance
    .post(API.ADD_SIFARISH_POINTS, data)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export const updateUserSifarish = (data = {}) => {
  return axiosInstance
    .post(API.UPDATE_USER_SIFARISH, data)
    .then((response) => response.data)
    .catch((err) => {
      throw err;
    });
};

export const undoDeletedSifarish = (data = {}) => {
  return axiosInstance
    .post(API.UNDO_DELETE_SIFARISH, data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
      }
      throw err;
    });
};

export const getExportSavedSifarish = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("userIdToRetrive", data?.userIdToRetrive);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);

  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.EXPORT_SAVED_SIFARISH}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getExportForwardedSifarish = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("userIdToRetrive", data?.userIdToRetrive);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);

  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.EXPORT_FORWARD_SIFARISH}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getExportReportedSifarish = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("userIdWhoReported", data?.userIdWhoReported);
  queryParams.append("showReportedOnly", data?.showReportedOnly || "");

  // Properly add categoryIds[] as multiple entries
  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.REPORTED_SIFARISH}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getExportSavedSifarishUser = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("sifarishId", data?.sifarishId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);

  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.EXPORT_SAVED_SIFARISH_USER}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getExportForwardedSifarishUser = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("sifarishId", data?.sifarishId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);

  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.EXPORT_FORWARD_SIFARISH_USER}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};

export const getExportReportedSifarishUser = (data = {}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("userId", data?.userId);
  queryParams.append("page", data?.page);
  queryParams.append("limit", data?.limit || null);
  queryParams.append("sifarishId", data?.sifarishId);

  // Properly add categoryIds[] as multiple entries
  if (Array.isArray(data?.categoryIds)) {
    data.categoryIds.forEach((id) => {
      queryParams.append("categoryIds[]", id);
    });
  }

  return axiosInstance
    .get(`${API.EXPORT_REPORTED_SIFARISH_USER}?${queryParams.toString()}`)
    .then((response) => response.data)
    .catch((err) => {
      console.log(err);
      throw err;
    });
};
